import React from "react";
import HeaderComponent from "../../components/Header";
import Footer from "../../components/Footer/footer";
import { constants } from "../../Constants";
import { connect } from "react-redux";
import { counsellorActions } from "../../store/actions";
import Loading from "../../components/Loading/Loading";
import doctorLogo from "../../static/images/doctorLogo.png";
import { history } from "../../helpers/history";
import { getCountryName } from "../../helpers/utils";

class CounsellorProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      countryName: null,
    };
  }

  // Get country name
  getCountryDetails = async () => {
    this.setState({ countryName: await getCountryName() });
  };

  componentDidMount() {
    if (!this.state.countryName) this.getCountryDetails();
  }

  componentWillMount() {
    this.props.getCounsellorProfile(this.props.match.params.id);
  }
  onError = (e) => {
    e.target.src = doctorLogo;
    e.target.onerror = "";
  };

  createAppointment = () => {
    const counsellor_id = this.props.match.params.id;
    history.push(`/create_appointment/${counsellor_id}`);
  };
  render() {
    const { counsellorProfile, whitelabel } = this.props;
    if (counsellorProfile && counsellorProfile.length > 0) {
      const profile = counsellorProfile[0];
      const paragraphs = profile.qualifications.split("\n");
      const paraFocused = profile.area_of_expertise.split("\n");
      return (
        <div className="sh-layout">
          <HeaderComponent />
          <div className="sh-counsellor-profile-detail-comp sh-gnrl-width">
            {/* Welcome Note */}
            <div className="sh-gnrl-welcome-note">
              <h2 className="sh-gnrl-welcome" id={""}>
                {constants.COUNSELLOR_PROFILE_TXT}
              </h2>
            </div>

            <div className="sh-cd-inner">
              <div className="left-profile">
                <div className="image-div">
                  <img src={profile.picture} onError={this.onError} />
                </div>

                <div className="button-box">
                  <button
                    onClick={this.createAppointment}
                    id="btnCancelCreateAppointment"
                    className="sh-gnrl-btn"
                  >
                    {constants.BOOK_NOW_TXT}
                  </button>
                </div>
              </div>

              <div className="detail-profile">
                <div className="inner">
                  <h4 className="head main-head">{profile.full_name}</h4>
                  {paragraphs.length > 0 ? (
                    paragraphs.map((a) => {
                      return <p className="desc">{a}</p>;
                    })
                  ) : (
                    <p className="desc">{profile.qualifications}</p>
                  )}

                  <h4 className="head text-black">Focused Areas</h4>

                  {paraFocused.length > 0 ? (
                    paraFocused.map((p) => {
                      return <p className="desc">{p}</p>;
                    })
                  ) : (
                    <p className="desc">{profile.area_of_expertise}</p>
                  )}

                  {whitelabel &&
                  whitelabel[0] &&
                  whitelabel[0].payment_required ? (
                    <p className="desc">
                      {profile.full_name} operates from {profile.home_city} and
                      charges{" "}
                      {this.state.countryName === "pakistan"
                        ? `${profile.price_pkr !== 0 && "PKR"} ${
                            profile.price_pkr ? profile.price_pkr : "N/A"
                          } `
                        : `${profile.price_usd !== 0 && "US $"}${
                            profile.price_usd ? profile.price_usd : "N/A"
                          } `}
                      per session.
                    </p>
                  ) : (
                    ""
                  )}

                  <div className="button-box mobile-view">
                    <button
                      onClick={this.createAppointment}
                      id="btnCancelCreateAppointment"
                      className="sh-gnrl-btn"
                    >
                      {constants.BOOK_NOW_TXT}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer></Footer>
        </div>
      );
    } else return <Loading />;
  }
}

function mapStateToProps(state) {
  const { session, auth, alert } = state;
  const { appointments, loading, updateStatus } = state.appointments;
  const { counsellorStatus, counsellorProfile } = state.counsellorStatus;
  const { user } = auth;
  const { whitelabel } = state.whitelabel;
  return {
    user,
    alert,
    appointments,
    session,
    counsellorStatus,
    loading,
    updateStatus,
    counsellorProfile,
    whitelabel,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCounsellorProfile: (id) => {
      dispatch(counsellorActions.getCounsellorProfile(id));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CounsellorProfile);



// WEBPACK FOOTER //
// ./src/screens/CounsellorProfile/index.js